export const MAX_COOKIE_SIZE = 4000;

export const REDIRECT_MAP = {
    basket: '/basket',
    home: '/',
    checkout: '/checkout',
    loves: '/lovelist',
    account: '/profile/MyAccount',
    rewards: '/rewards',
    offers: '/beauty/beauty-offers',
    purchases: '/profile/MyAccount/OrderHistory'
};

export const DEFAULT_REDIRECT = '/';
